
// Refactored stock-menu-panel with native primitives
AFRAME.registerComponent('stock-menu-panel', {
    schema: {
        apiKey: { type: 'string', default: '' }
    },

    init: function () {
        console.log("Creating stock chart menu");
        this.createMenu();
    },

    createMenu: function () {
        const menu = document.createElement('a-rounded-plane');
        menu.setAttribute('width', '1');
        menu.setAttribute('height', '3');
        menu.setAttribute('color', '#888');
        menu.setAttribute('opacity', '.1');
        menu.setAttribute('position', '.83 -2.5 0.1');

        // Using native primitives
        this.createInput(menu, 'stockSymbol', 'Stock Symbol', '0.49 2.8 0.1');
        this.createDropdown(menu, 'multiplier',  'Multiplier', ['Select', '1', '5', '15', '30', '60', '120'], '0.49 2.25 0.1');
        this.createDropdown(menu, 'timespan', 'Timespan', ['Select', 'minute', 'hour', 'day', 'week', 'month'], '0.49 1.75 0.1');
        this.createDatePicker(menu, 'startDate',  'Start Date', [-30,0],'0.49 1.25 0.1');
        this.createDatePicker(menu, 'endDate',  'End Date', [-30,0],'0.49 .75 0.1');
        this.createButton(menu, 'Fetch Data', 'fetchDataButton', '0.49 0.25 0.1');

        this.el.appendChild(menu);
    },

    createInput: function (parent, id, placeholder, position) {
        const input = document.createElement('ui-input');
        input.setAttribute('id', id);
        input.setAttribute('placeholder', placeholder);
        input.setAttribute('position', position);
        input.setAttribute('width', '0.75');
        input.setAttribute('height', '0.2');
        parent.appendChild(input);
    },

    createDropdown: function (parent, id, label, options, position) {
        const dropdown = document.createElement('ui-dropdown');
        dropdown.setAttribute('id', id);
        dropdown.setAttribute('label', label);
        dropdown.setAttribute('options', JSON.stringify(options));
        dropdown.setAttribute('width', '0.75');
        dropdown.setAttribute('height', '0.2');
        dropdown.setAttribute('position', position);
        parent.appendChild(dropdown);
    },

    createDatePicker: function (parent, id, label, options, position) {
        const datepicker = document.createElement('ui-datepicker');
        datepicker.setAttribute('id', id);
        datepicker.setAttribute('label', label);
        datepicker.setAttribute('options', JSON.stringify(options));
        datepicker.setAttribute('width', '0.75');
        datepicker.setAttribute('height', '0.2');
        datepicker.setAttribute('position', position);
        parent.appendChild(datepicker);
    },

    createButton: function (parent, label, id, position) {
        const button = document.createElement('ui-button');
        button.setAttribute('id', id);
        button.setAttribute('position', position);
        button.setAttribute('type', 'rounded-box');
        button.setAttribute('cornerstyle', 'ext');
        button.setAttribute('opacity', '0.3');
        button.setAttribute('autosize', false);

        button.setAttribute('label', label);
        button.setAttribute('width', '0.75');
        button.setAttribute('height', '0.2');
        button.setAttribute('depth', '0.05');
        button.setAttribute('color', '#008CBA');
        parent.appendChild(button);
    },

    generateDateOptions: function () {
        let options = [];
        let today = new Date();
        for (let i = 0; i < 30; i++) {
            let date = new Date();
            date.setDate(today.getDate() - i);
            options.push(date.toISOString().split('T')[0]);
        }
        return options;
    }
});